<template>
    <div class="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
        <div class="sm:mx-auto sm:w-full sm:max-w-sm">
            <img class="mx-auto h-10 w-auto" src="/img/birdie-logo.svg" alt="Birdie" />
            <h2 class="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">Test s3 bucket
                config</h2>

            <p class="mt-3 text-center text-sm text-gray-500">Quick test to confirm your S3 bucket is set up
                correctly.<br />Refer to <a
                    href="https://docs.birdie.so/birdie-docs/security/storage-location#storage-in-your-own-aws-s3-bucket"
                    class="text-blue-500 hover:underline" target="_blank">the docs</a> for detailed instructions.</p>
        </div>

        <div class=" mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
            <form class="space-y-6">
                <div>
                    <label for="arn" class="block text-sm font-medium leading-6 text-gray-900">IAM Role
                        ARN</label>
                    <div class="mt-2">
                        <input type="hidden" name="_token" :value="csrf_token" />
                        <input id="arn" name="arn" v-model="arn" type="text"
                            placeholder="arn:aws:iam::593312684024:role/my-role"
                            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    </div>
                </div>

                <div v-if="false">
                    <label for="key" class="block text-sm font-medium leading-6 text-gray-900">IAM User: Access
                        Key ID
                        (only if you don’t use the ARN Role)</label>
                    <div class="mt-2">
                        <input id="key" name="key" v-model="key" type="text" placeholder="ADFA3TFZ0VDWQ4FTZTF8"
                            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    </div>
                </div>


                <div v-if="false">
                    <label for="secret" class="block text-sm font-medium leading-6 text-gray-900">IAM User:
                        Secret
                        Access Key (only if you don’t use the ARN Role)</label>
                    <div class="mt-2">
                        <input id="secret" name="secret" v-model="secret" type="text"
                            placeholder="jf9q7Epd5W2JhCxw6VcdPSqBe2spLFtvwSvkBXW3"
                            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    </div>
                </div>

                <div>
                    <div class="flex items-center justify-between">
                        <label for="bucket" class="block text-sm font-medium leading-6 text-gray-900">Bucket
                            name</label>
                    </div>
                    <div class="mt-2">
                        <input id="bucket" name="bucket" v-model="bucket" type="text" required="true"
                            placeholder="birdie-videos-bucket"
                            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    </div>
                </div>

                <div>
                    <div class="flex items-center justify-between">
                        <label for="region" class="block text-sm font-medium leading-6 text-gray-900">Region</label>
                    </div>
                    <div class="mt-2">
                        <input id="region" name="region" v-model="region" type="text" required="true"
                            placeholder="us-east-2"
                            class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                    </div>
                </div>

                <div v-if="results">
                    <div class="mt-2">
                        <div class="text-sm text-gray-900">

                            <h3 class="text-lg font-semibold text-gray-800">Results:</h3>

                            <ul class="list-disc list-inside">

                                <li :class="[results.credentialsSuccess ? 'text-green-600' : 'text-red-600',
                                    'flex items-center gap-x-3'
                                ]">
                                    <CheckIcon v-if="results.credentialsSuccess" class="w-4 h-4" />
                                    <XMarkIcon v-else class="w-4 h-4" />
                                    <span>Credentials</span>
                                </li>

                                <li :class="[!results.credentialsSuccess ? 'text-gray-600' : results.writeSuccess ? 'text-green-600' : 'text-red-600',
                                    'flex items-center gap-x-3'
                                ]">
                                    <CheckIcon v-if="results.writeSuccess" class="w-4 h-4" />
                                    <XMarkIcon v-else class="w-4 h-4" />
                                    <span>Write to bucket</span>
                                </li>

                                <li :class="[!results.credentialsSuccess || !results.writeSuccess ? 'text-gray-600' : results.listSuccess ? 'text-green-600' : 'text-red-600',
                                    'flex items-center gap-x-3'
                                ]">
                                    <CheckIcon v-if="results.listSuccess" class="w-4 h-4" />
                                    <XMarkIcon v-else class="w-4 h-4" />
                                    <span>List objects</span>
                                </li>

                                <li :class="[!results.credentialsSuccess || !results.writeSuccess ? 'text-gray-600' : results.sizeSuccess ? 'text-green-600' : 'text-red-600',
                                    'flex items-center gap-x-3'
                                ]">
                                    <CheckIcon v-if="results.sizeSuccess" class="w-4 h-4" />
                                    <XMarkIcon v-else class="w-4 h-4" />
                                    <span>Get size</span>
                                </li>

                                <li :class="[!results.credentialsSuccess || !results.writeSuccess ? 'text-gray-600' : results.readSuccess ? 'text-green-600' : 'text-red-600',
                                    'flex items-center gap-x-3'
                                ]">
                                    <CheckIcon v-if="results.readSuccess" class="w-4 h-4" />
                                    <XMarkIcon v-else class="w-4 h-4" />
                                    <span>Read file</span>
                                </li>

                                <li :class="[!results.credentialsSuccess || !results.writeSuccess ? 'text-gray-600' : results.deleteFileSuccess ? 'text-green-600' : 'text-red-600',
                                    'flex items-center gap-x-3'
                                ]">
                                    <CheckIcon v-if="results.deleteFileSuccess" class="w-4 h-4" />
                                    <XMarkIcon v-else class="w-4 h-4" />
                                    <span>Delete file</span>
                                </li>

                                <li :class="[!results.credentialsSuccess || !results.writeSuccess ? 'text-gray-600' : results.deleteDirSuccess ? 'text-green-600' : 'text-red-600',
                                    'flex items-center gap-x-3'
                                ]">
                                    <CheckIcon v-if="results.deleteDirSuccess" class="w-4 h-4" />
                                    <XMarkIcon v-else class="w-4 h-4" />
                                    <span>Delete directory</span>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>

                <div>
                    <button type="button" @click="submitForm" :disabled="loading"
                        class="flex w-full justify-center rounded-md bg-birdie-blue px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-birdie-blue"
                        v-html="loading ? 'Loading…' : 'Start test'"></button>

                </div>

            </form>

        </div>
    </div>

</template>

<script>
//import AppLayout from '@/Layouts/AppLayout'
import { XMarkIcon, CheckIcon } from "@heroicons/vue/20/solid";

export default {
    props: {
        csrf_token: String,
        params: Array,
    },
    //layout: AppLayout,
    components: {
        XMarkIcon, CheckIcon
    },

    data() {
        return {
            arn: this.params.arn ?? '',// 'arn:aws:iam::992382380794:role/test-role', //'rn:aws:iam::302157828541:role/BirdieCx',
            key: this.params.key ?? '',
            secret: this.params.secret ?? '',
            bucket: this.params.bucket ?? '',// 'birdie-bucket', //'stage-use1-birdie-cx',
            region: this.params.region ?? '',// 'us-west-2', //'us-east-1',
            results: this.params.results ?? null,
            loading: false,
        }
    },
    created() {
        //console.log("params", this.params)
        // this.EventBus.on("start.call", function(toto) {
        //     this.test(toto)
        // }.bind(this));
        //console.log(this.is_visitor)

    },
    beforeUnmount() {
        // this.EventBus.off("start.call", this.test);
    },
    mounted() {
        // this.EventBus.emit("start.call", "hello")
    },
    methods: {
        submitForm() {
            if (this.arn == '') { //} && (this.key == '' || this.secret == '')) {
                let options = {
                    type: "warning",
                    timeout: 10000,
                    position: "top-right",
                    hideProgressBar: false,
                }
                this.$moshaToast("You must provide the Role ARN", options)
                return
            }
            if (this.bucket == '') {
                let options = {
                    type: "warning",
                    timeout: 10000,
                    position: "top-right",
                    hideProgressBar: false,
                }
                this.$moshaToast("You must provide the bucket and the region", options)
                return
            }
            if (this.region == '') {
                let options = {
                    type: "warning",
                    timeout: 10000,
                    position: "top-right",
                    hideProgressBar: false,
                }
                this.$moshaToast("You must provide the bucket and the region", options)
                return
            }
            let url = this.$page.props.app_url + '/test-s3';
            var params = {
                bucket: this.bucket,
                arn: this.arn,
                key: this.key,
                secret: this.secret,
                region: this.region
            }
            this.loading = true
            this.results = null
            axios.post(url, params)
                .then(response => {
                    this.results = response.data
                    this.loading = false

                    if (!this.results.credentialsSuccess ||
                        !this.results.writeSuccess ||
                        !this.results.listSuccess ||
                        !this.results.readSuccess ||
                        !this.results.deleteDirSuccess ||
                        !this.results.deleteFileSuccess) {
                        let options = {
                            type: "danger",
                            timeout: -1,
                            position: "top-right",
                        }
                        this.$moshaToast("Test Failed", options)
                        return
                    }

                    let options = {
                        type: "default",
                        timeout: 2500,
                        position: "top-right",
                        hideProgressBar: false,
                    }
                    this.$moshaToast("Test Success", options)

                })
                .catch(e => {
                    console.error(e);

                    let options = {
                        type: "danger",
                        timeout: -1,
                        position: "top-right",
                    }
                    this.$moshaToast("Could not test, an error occured", options)

                    this.loading = false
                });
        }
    },
    computed: {

    }
}
</script>

<style></style>
